import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'subscription-pullup',
})

export default class SubscriptionPullup extends Vue {

    @Prop()
    private selectedRow: any;

    private isOkdisable = true;

    private selectedRequestOption: any;

    private updateStatus: boolean = false;

    private dismissCountDown: number = 0;

    private dismissSecs: number = 3;

    private requestOptions: any = [
        // { text: 'Requested', value: 'requested'},
        { text: 'Inreview', value: 'inreview' },
        { text: 'Declined', value: 'declined' },
        { text: 'Active', value: 'active' },
        { text: 'Inactive', value: 'inactive' },
        { text: 'Requested', value: 'requested' },
    ];

    private tableFields: any = [
        { label: 'Name', key: 'tenantName' },
        { label: 'Client Id', key: 'clientId' },
        { label: 'Status', key: 'subscribeStatus' },
        { label: 'Update Status', key: 'update' },
    ];

    private onClose() {
        this.$emit('onClose');
    }

    private onUpdateSubscribe(selected: any) {
        this.$emit('onUpdateSubscribe', this.selectedRow, selected);
        selected.selectedRequestOption = selected.selectedRequested;
        this.updateStatus = true;
        this.showAlert();
    }

    private countDownChanged(dismissCountDown: number) {
        this.dismissCountDown = dismissCountDown;
    }
    private showAlert() {
        this.dismissCountDown = this.dismissSecs;
    }
    private OnchangeStatus(currentStatus: string, requestStatus: string, index: number) {
        const buttonOK = this.$el.querySelector(`#btn-ok-${index}`) as HTMLElement;
        if (requestStatus !== 'requested') {
            buttonOK.removeAttribute('disabled');
        } else {
            buttonOK.setAttribute('disabled', 'disabled');
        }

    }
}
